import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  submit(event) {
    const checked = event.target.checked;
    const organizationId = this.element.dataset.organizationId;
    const key = this.element.dataset.key;
    const action = this.element.dataset.actionName;

    if (checked) {
      fetch("/settings/organization_permissions/grant", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
        },
        body: JSON.stringify({
          organization_id: organizationId,
          key,
          action,
        }),
      }).then((response) => {
        if (!response.ok) {
          event.target.checked = !checked; // Revert toggle if request failed
        }
      });
    } else {
      fetch("/settings/organization_permissions/revoke", {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
        },
        body: JSON.stringify({
          organization_id: organizationId,
          key,
          action,
        }),
      }).then((response) => {
        if (!response.ok) {
          event.target.checked = !checked; // Revert toggle if request failed
        }
      });
    }
  }
}

